export default __webpack_public_path__ + "static/meaningful_silence-0e4b5cff9038f8475705617193e51079.png";